module.exports = __webpack_public_path__ + "img/stripe.14e67e24.png";